var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"assign-withdraw"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.emailLinkText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }